module.exports = __webpack_public_path__ + "img/utilityvalvac_parked.4705e15f.svg";